
<form #userForm="ngForm" (ngSubmit)=onSubmit(userForm) class="m-auto auth auth-background" >
  <div class="container-fluid">
    <div class="row pi-login  justify-content-center align-items-center">
      <div class="col-md-12 ">
        <div class="header-w3l">
          <div class="logo ml-2">
            <h3 class="d-flex justify-content-center align-items-center "><a href="#"><img src="./assets/images/Group1.png" alt=""></a></h3>
          </div>
        </div>
      </div>
        
      <div class="col-12 mt-5  text-center d-flex justify-content-center">
        <div class="w-25 mob-tab d-flex justify-content-center center-button">
          <div class="login" (click)="switchTab('login')" [ngStyle]="loginTab ? { 'background': 'rgba(219, 72, 39, 1)', 'border-radius': '50px' } : {'background':'rgba(52, 33, 82, 1)','border-radius':'50px'}">Login</div>
          <div class="register" (click)="switchTab('register')" [ngStyle]="registerTab ? { 'background': 'rgba(219, 72, 39, 1)', 'border-radius': '50px' } : {'background':'rgba(52, 33, 82, 1)','border-radius':'50px'}">Register</div>
        </div>
        <!-- <h3 class="login-label mb-2 ml-2">{{ 'COMMON.LOGIN' | translate }}</h3> -->
      </div>
      <div class="col col-sm-6 col-md-7 col-lg-3 text-center mt-4 p-0" *ngIf="loginTab" >
        
        <label for="" class="d-flex justify-content-start">  {{'PLACEHOLDER.EMAIL' | translate}}</label>
        <div class="form-group mb-2 ">
          <i class="fa fa-envelope text-white input-icon" aria-hidden="true"></i>
          <input type="text" [(ngModel)]="user.username" class="form-control in" name="username"
          #username="ngModel" placeholder="{{ 'PLACEHOLDER.EMAIL' | translate }}" (keypress)="preventSpace($event)" maxlength="120" required autofocus>
        </div>
        <!-- <div class="form-control-feedback text-left pt-0"
          *ngIf="username.errors && (username.dirty || username.touched)">
       <p *ngIf="username.errors.required" class="error-msg">User name is required</p>
     </div> -->
          <div *ngIf="userForm.submitted && username.invalid" class="text-left pt-0">
            <p class="error-msg mb-0">Email is required</p>
          </div>

        <label for="" class="d-flex justify-content-start mt-3"> {{'LABEL.PASSWORD' | translate}}</label>

        <div class="form-group mb-2 mt-2">
          <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
          <input [type]="type" [(ngModel)]="user.otp" class="form-control-pass in" name="password" (keyup.enter)="onSubmit(userForm)"
            #password="ngModel"  placeholder="{{ 'PLACEHOLDER.PASSWORD' | translate }}"   maxlength="15" required autofocus>
            <div class="input-append cursor-pointer text-white" (click)="hideShowPassword()">
              <i class="fas fa-eye " *ngIf="type == 'password'"></i>
              <i class="fas fa-eye-slash " *ngIf="type !== 'password'"></i>
            </div> 
          </div>
          <div *ngIf="userForm.submitted && password.invalid  && !user.otp?.length" class="text-left pt-0">
            <p class="error-msg mb-0">{{ 'FORMERROR.PASSWORD' | translate }}</p>
          </div>
         
       
        <!-- <div class="form-group mb-lg-5 mb-4 mt-4">
          <div class="d-flex ml-0 justify-content-start">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheck1" (change)="rememberMe($event)">
              <label class="custom-control-label" for="customCheck1">{{ 'COMMON.REMLOGIN' | translate }}</label>
            </div>
          </div>
        </div> -->
        <div class="back-url d-flex justify-content-between align-items-center">
          <div class="back pl-3 mt-2"><i class="fa fa-arrow-left" routerLink="/add-playlist"></i></div>
          <div class="d-flex justify-content-end forgot-password" routerLink="/forgot-password">Forget Password</div>
        </div>
        <div class="row justify-content-center align-items-center mt-3">
          <div class="col-md-6 mr-2" style="padding-right: 0px;padding-left: 0px;">
            <button class="login-btns  btn" type="submit" [disabled]="isLoading" >
              {{ 'COMMON.LOG_IN' | translate }}
              <div *ngIf="isLoading" class="spinner-border spinner-border-sm fs-14" role="status">
                <span class="sr-only">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
            </button>
          </div>
          <div class="col-md-5 ml-2" style="padding-right: 0px;padding-left: 0px;">
            <button class="login-codes btn ml-0 mr-5" (click)="checkCodeLogin()">
              Skip</button>
          </div>
        </div>
        <!-- <div class="col-12 pb-0 d-flex">
          <h5 class="mb-0 mt-5 text-size ">
        <i class="fa fa-arrow-left" aria-hidden="true" routerLink="/add-playlist"></i>
            
            {{ 'LOGIN.DONTACC' | translate }} <a class="ml-1 text-purple"
              routerLink="/register">{{ 'COMMON.SIGNUP' | translate }}</a></h5>
        </div> -->
      </div>
       <form #registerForm="ngForm" (ngSubmit)="onRegisterSubmit(registerForm)" style="width: 100%; display: contents;">
  <div class="col col-sm-6 col-md-7 col-lg-3 text-center mt-4 p-0" *ngIf="registerTab">

    <!-- First & Last Name -->
    <div class="fistname-lastname d-flex justify-content-between">
      <!-- First Name -->
      <div class="fname mr-2">
        <label class="d-flex justify-content-start">First Name</label>
        <div class="form-group mb-2">
          <i class="fa fa-user text-white input-icon" aria-hidden="true"></i>
          <input
            type="text"
            class="form-control in"
            [(ngModel)]="registerUser.firstName"
            name="firstName"
            required
            #firstName="ngModel"
            placeholder="First Name"
            (keypress)="preventSpace($event)"
            maxlength="120"
            autofocus
          />
        </div>
        <p class="text-left text-danger" *ngIf="firstName.invalid && firstName.touched">
          First name is required.
        </p>
      </div>

      <!-- Last Name -->
      <div class="lname ml-2">
        <label class="d-flex justify-content-start">Last Name</label>
        <div class="form-group mb-2">
          <i class="fa fa-user text-white input-icon" aria-hidden="true"></i>
          <input
            type="text"
            class="form-control in"
            [(ngModel)]="registerUser.lastName"
            name="lastName"
            required
            #lastName="ngModel"
            placeholder="Last Name"
            (keypress)="preventSpace($event)"
            maxlength="120"
            autofocus
          />
        </div>
        <p class="text-left text-danger" *ngIf="lastName.invalid && lastName.touched">
          Last name is required.
        </p>
      </div>
    </div>

    <!-- Email -->
    <label class="d-flex justify-content-start">Email</label>
    <div class="form-group mb-2 mt-2">
      <i class="fa fa-envelope text-white input-icon" aria-hidden="true"></i>
      <input
        type="text"
        class="form-control in"
        placeholder="Email"
        name="email"
        [(ngModel)]="registerUser.email"
        required
        #email="ngModel"
      />
    </div>
    <p class="text-left text-danger" *ngIf="email.invalid && email.touched">
      Email is required.
    </p>

    <!-- Password -->
    <label class="d-flex justify-content-start mt-3">Password</label>
    <div class="form-group mb-2 mt-2 position-relative">
      <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
      <input
        [type]="registerPasswordType"
        class="form-control-pass in"
        name="password"
        placeholder="Password"
        [(ngModel)]="registerUser.password"
        maxlength="15"
        required
        #password="ngModel"
        autofocus
      />
      <div class="input-append cursor-pointer text-white" (click)="hideShowRegisterPassword()">
        <i class="fas fa-eye" *ngIf="registerPasswordType === 'password'"></i>
        <i class="fas fa-eye-slash" *ngIf="registerPasswordType !== 'password'"></i>
      </div>
    </div>
    <p class="text-left text-danger" *ngIf="password.invalid && password.touched">
      Password is required.
    </p>
    <label class="d-flex justify-content-start mt-3">Confirm Password</label>
<div class="form-group mb-2 mt-2 position-relative">
  <i class="fa fa-key text-white input-icon" aria-hidden="true"></i>
  <input
    [type]="confirmPasswordType"
    class="form-control-pass in"
    name="confirmPassword"
    placeholder="Confirm Password"
    [(ngModel)]="registerUser.confirmPassword"
    required
    #confirmPassword="ngModel"
  />
   <div class="input-append cursor-pointer text-white" (click)="hideShowConfirmPassword()">
        <i class="fas fa-eye" *ngIf="confirmPasswordType === 'password'"></i>
        <i class="fas fa-eye-slash" *ngIf="confirmPasswordType !== 'password'"></i>
      </div>
</div>
<p class="text-left text-danger" *ngIf="confirmPassword.invalid && confirmPassword.touched">
  Confirm password is required.
</p>


    <!-- Submit Button -->
    <div class="form-group mt-4 text-center add-btn">
      <button type="submit" class="btn  w-50" >
        Register
      </button>
    </div>
  </div>
</form>

    </div>
  </div>
</form>
